import "./general-message.scss";

import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { FunctionComponent } from "react";

import { useRootContext } from "@client/context/RootContext";

interface GeneralMessageProps {
	title?: string;
	subtitle?: string;
	error?: string;
	imgSrc?: string;

	whiteOnBlack?: boolean;

	buttonLabel?: string;
	buttonAction?: () => void;

	buttonLabel2?: string;
	buttonAction2?: () => void;
	printAgain?: boolean;
}

export const GeneralMessage: FunctionComponent<GeneralMessageProps> = observer(
	({
		title,
		subtitle,
		error,
		imgSrc,
		whiteOnBlack,
		buttonLabel = "Ok",
		buttonAction,
		buttonLabel2,
		buttonAction2,
		printAgain,
	}) => {
		const {
			printStore: { printShippingLabel, orderReference },
		} = useRootContext();

		return (
			<div
				className={classNames("general-message-wrapper", {
					"wrapper-black": whiteOnBlack,
				})}
			>
				<div
					className={classNames("general-message-container", {
						"container-black": whiteOnBlack,
					})}
				>
					{imgSrc && <img className="general-message-img" src={imgSrc} />}

					{title && (
						<div className={classNames("general-message-title", "modal")}>
							{title}
						</div>
					)}
					{subtitle && (
						<div className="general-message-subtitle">{subtitle}</div>
					)}

					{error && process.env.ENVIRONMENT !== "production" && (
						<div className="general-message-error">{error}</div>
					)}

					<div className="general-message-buttons">
						{buttonLabel && buttonAction && (
							<button
								className={
									whiteOnBlack ? "general-message-black" : "general-message-btn"
								}
								onClick={buttonAction}
							>
								{buttonLabel}
							</button>
						)}
						{buttonLabel2 && buttonAction2 && (
							<button
								className={
									whiteOnBlack
										? "general-message-black2"
										: "general-message-btn"
								}
								onClick={buttonAction2}
							>
								{buttonLabel2}
							</button>
						)}
						{printAgain && (
							<button
								className={"general-message-btn try-again"}
								onClick={() => {
									printShippingLabel(orderReference);
									buttonAction?.();
								}}
							>
								{"Try again"}
							</button>
						)}
					</div>
				</div>
			</div>
		);
	}
);
